import React, { useRef, useEffect, useState, useContext, useCallback } from 'react';

import { useHistory } from "react-router-dom";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { confirmDialog } from 'primereact/confirmdialog';
import { Toast } from 'primereact/toast';
import { Dropdown } from 'primereact/dropdown';
import { DialogCursos } from './DialogCursos';
import '../layout/sass/_pickListSugestoes.scss'
import '../layout/sass/_responsiveTable.scss'
import { PermissaoLoader } from "./PermissaoLoader";
import { permissions_check } from "../utils/rotas_permissao";

import api from '../api/api';

import {FilterContext} from '../contexts/FilterContext';
import {AuthContext} from '../contexts/AuthContext';

export const TabelaTipoCursos = () => {
    const toast = useRef(null);
    const [tipoCursosTotal, setTipoCursosTotal] = useState([]);
    const [tipoCursos, setTipoCursos] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isDeleting, setIsDeleting] = useState(false);
    const confirmationToast = useRef(null)
    const [dt, setDt] = useState(null);
    const history = useHistory();
    const [showListaTipoCursos, setShowTipoListaCursos] = useState(false);        
    const { user, permissoes } = useContext(AuthContext);
    const [showActionsColumn, setShowActionsColumn] = useState(true);

    const [sortable, setSortable] = useState('ASC');
    const [sortableCampo, setSortableCampo] = useState('id');
    const [first, setFirst] = useState(0);
    const [totalRecords, setTotalRecords] = useState(0);
    const [selectedStatus, setSelectedStatus] = useState(null);
    const [tipos, setTipos] = useState([]);
    const filterStatus = renderFilterStatus();
    const { filter, setFilter } = useContext(FilterContext);

    const header = (
      <div className="p-grid p-col-12 p-m-0 p-p-0">
        <div>
          <h2 className="p-my-0">Tipo Cursos</h2>
        </div>
        <div className="p-my-0 p-grid p-dir-rev p-col">
          <div className="p-m-2">
            <PermissaoLoader
              rota="tipoCursos"
              acao="criar"
              onClick={() => history.push('/tipoCursos/create')}
            />
          </div>
          <div className="p-m-2">
            <Button
              label="Limpar Filtros"
              className="p-mb-2 p-button-primary"
              iconPos="left"
              type="button"
              onClick={() => handleLimparClick()}
            />
          </div>
        </div>
      </div>
    );

    const handleLimparClick = () => {
        setFilter({
            first: 0,
            rows: 20,
            sortField: null,
            sortOrder: null,
            filters: {
            },
            
        });
        setSelectedStatus(null);
    }

    const getTipoCursos = useCallback(async (event) => {
        setIsLoading(true)
        setTipoCursos([])

        // console.log(event)   

        if(event !== undefined) {
            setTimeout(() => {
                const startIndex = event.first;

                setFirst(startIndex);
                // setCursos(dataSource.slice(startIndex, endIndex));            
            }, 250);
        }
       
        try {

            if(filter.filters === undefined) 
            {

                if(event === undefined) {
                    const response = await api.get(`tipo-cursos?sort=${sortableCampo},${sortable}`);
                    response.data.content.forEach(curso => {
                        setTipoCursos(cursos => [...cursos, curso])
                    })                
                } else {
                    const response = await api.get(`tipo-cursos?page=${event.page}&sort=${sortableCampo},${sortable}`);
                    response.data.content.forEach(curso => {
                        setTipoCursos(cursos => [...cursos, curso])
                    })  
                    
                }

                const respElements = await api.get(`tipo-cursos?sort=${sortableCampo},${sortable}`);
                setTotalRecords(respElements.data.totalElements);

            } 
            else 
            {     
                const pesquisa = {
                    "id": filter.filters['id'] !== undefined ? filter.filters['id'].value : null,
                    "nome": filter.filters['nome'] !== undefined ? filter.filters['nome'].value : "",
                    "cor": filter.filters['cor'] !== undefined ? filter.filters['cor'].value : ""
                }

                if (event === undefined) {   
                    const respElements = await api.post(`tipo-cursos/searchCurso/${sortable}/${sortableCampo}?`, pesquisa);
                    respElements.data.content.forEach(curso => {
                        setTipoCursos(cursos => [...cursos, curso])
                    })
                    setTotalRecords(respElements.data.totalElements);
                } else {
                    const respElements = await api.post(`tipo-cursos/searchCurso/${sortable}/${sortableCampo}?page=${event.page}`, pesquisa);
                    respElements.data.content.forEach(curso => {
                        setTipoCursos(cursos => [...cursos, curso])
                    })
                    setTotalRecords(respElements.data.totalElements);
                }
            }
            
            
            
        }
        catch (error) {  

            if(filter !== undefined){
                if(event === undefined) {
                    const response = await api.get(`tipo-cursos?sort=${sortableCampo},${sortable}`);
                    response.data.forEach(curso => {
                        setTipoCursos(cursos => [...cursos, curso])
                    })                  
                } else {
                    const response = await api.get(`tipo-cursos?page=${event.page}&sort=${sortableCampo},${sortable}`);
                    response.data.content.forEach(curso => {
                        setTipoCursos(cursos => [...cursos, curso])
                    }) 
                    
                }

                const respElements = await api.get(`tipo-cursos?sort=${sortableCampo},${sortable}`);
                setTotalRecords(respElements.data.totalElements);
            } else {
                toast.current.show({ severity: 'error', summary: 'Erro ao obter cursos', detail: error.toString() });    
            }
              
        }

        setIsLoading(false)
    }, [filter,sortable,sortableCampo]);

    useEffect(() => {
        const fetchTipoCursos = async () => {
            try {
                await getTipoCursos();

            }
            catch (error){
                toast.current.show({ severity: 'error', summary: 'Erro ', detail: error.toString() });
            }
        }
        fetchTipoCursos();

    }, [getTipoCursos])

    function renderFilterStatus() {
        return (
            <Dropdown
                value={selectedStatus}
                options={tipos}
                onChange={(e) => onStatusSearchChange(e)}
                placeholder="Selecione um tipo"
                className="p-column-filter"
                showClear={true} />
        );
    }

    const onStatusSearchChange = (event) => {
        if (event.value !== null) {
            dt.filter(event.value, 'cor', 'equals');
            setSelectedStatus(event.value);
        }
        else
            dt.filter(null, 'cor', 'equals');
    }

    const actionBodyTemplate = (rowData) => {
      const hasEditPermission = permissions_check(
        "tipoCursos",
        "editar",
        permissoes
      );
      const hasDeletePermission = permissions_check(
        "tipoCursos",
        "deletar",
        permissoes
      );
      if (!hasEditPermission && !hasDeletePermission) {
        setShowActionsColumn(false);
      } else {
        return (
          <div className="actions">
            {hasEditPermission ? (
              <Button
                icon="pi pi-pencil"
                className="p-button-rounded p-mr-2 edit-btn"
                onClick={() => handleEditClick(rowData)}
              />
            ) : (
              <></>
            )}
            {hasDeletePermission ? (
              <Button
                icon="pi pi-trash"
                className="p-button-rounded p-mr-2 p-button-danger"
                loading={isDeleting}
                onClick={() => handleDeleteClick(rowData)}
              />
            ) : (
              <></>
            )}
          </div>
        );
      }
    };

    const codBodyTemplate = (rowData) => {
        return(
            <React.Fragment>
                <p style={{textalign: 'left'}}>
                    <span className="p-column-title">Código</span>
                    <span className="table-data">{rowData.id}</span>
                </p>
            </React.Fragment>
        );
    }

    const nomeBodyTemplate = (rowData) => {
        return(
            <React.Fragment>
                <p style={{textalign: 'left'}}>
                    <span className="p-column-title">Nome</span>
                    <span className="table-data">{rowData.nome}</span>
                </p>
            </React.Fragment>
        );
    }

    const corBodyTemplate = (rowData) => {
        return(
            <React.Fragment>
                <p style={{ textAlign: 'center' }}>
                <span className="p-column-title">Cor</span>
                <span
                    className="table-data"
                    style={{
                        display: 'inline-block',
                        width: '40px',
                        height: '20px',
                        backgroundColor: `#${rowData.cor}`,
                        border: '1px solid #ccc',
                        borderRadius: '4px',
                        marginLeft: '10px',
                        verticalAlign: 'middle',
                    }}
                ></span>
            </p>
            </React.Fragment>
        );
    }    

    const onSort = (event) => {
        setSortableCampo(event.sortField);
        if(sortable === 'ASC'){
            setSortable('DESC')
        } else if (sortable === 'DESC') {
            setSortable('ASC')
        }
    }

    const onFilter = (event) => {
        event['first'] = 0;
        // setLazyParams(event);
        setFilter(event);   
    }

  
    const handleEditClick = (data) => {

        history.push(`/tipoCursos/edit/${data.id}`);
    }
    
    const handleDeleteClick = (data) => {

        data['userEmail'] = user.email

        confirmDialog({
            message: `Você tem certeza que quer remover ${data.nome}?`,
            header: 'Confirmação',
            icon: 'pi pi-exclamation-triangle',
            acceptClassName: 'p-button-danger',
            acceptLabel: 'Sim',
            rejectLabel: 'Não',
            accept: async () => {
                setIsDeleting(true);

                try {

                    await api.delete(`tipo-cursos/${data.id}`);       
                    toast.current.show({ life: 5000, severity: 'success', summary: 'Remoção concluída!', detail: `Curso ${data.nome} removido(a) com sucesso` });
                    getTipoCursos()
                }
                catch (error) {
                    toast.current.show({ life: 5000, severity: 'error', summary: 'Erro ao remover o curso', detail: error.response.data });
                }

                setIsDeleting(false);
            },
            reject: () => { return }
        });
    }

    const handlePrintClick = () => {
        setShowTipoListaCursos(true);
    }

    const getTipoCursosAll = useCallback(async () => {
        try {
            const response = await api.get(`tipo-cursos`);
            setTipoCursosTotal(response.data)
        }
        catch (error) {
            toast.current.show({ severity: 'error', summary: 'Erro ao obter cursos', detail: error.toString() });
        }
    }, []);

    useEffect(() => {

        async function tipoCursos() {
            await getTipoCursosAll();            
        }
        tipoCursos();

    }, [getTipoCursosAll])

    return (
      <>
        <div className="card p-grid p-col-12 p-mx-0 p-p-0 p-mt-0">
          <DialogCursos
            visible={showListaTipoCursos}
            setVisible={setShowTipoListaCursos}
            curso={tipoCursosTotal}
          />
          <div className="p-my-0 p-dir-rev p-col">
            <div className="p-my-0">
              <Button
                textalign="center"
                icon="pi pi-print"
                className="p-button-secondary"
                style={{ width: "35px" }}
                onClick={handlePrintClick}
                tooltip="Gerar relatório"
                tooltipOptions={{ position: "top" }}
              />
            </div>
          </div>

          <Toast ref={toast} position="bottom-right" />

          <Toast ref={confirmationToast} position="bottom-center" />

          <div className="card p-col-12 datatable-responsive-demo">
            <div className="p-fluid">
              <DataTable
                totalRecords={totalRecords}
                lazy="true"
                first={first}
                onPage={getTipoCursos}
                ref={(element) => setDt(element)}
                header={header}
                value={tipoCursos}
                filterDisplay="row"
                className="p-datatable-responsive-demo"
                emptyMessage="Nenhum curso encontrado"
                loading={isLoading}
                dataKey="id"
                paginator
                rows={20}
                currentPageReportTemplate={`Mostrando de {first} a {last} de ${totalRecords} cursos`}
                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport"
                // rowsPerPageOptions={[10, 20, 30]}
                onSort={onSort}
                onFilter={onFilter}
                filters={filter.filters}
              >
                <Column
                  field="id"
                  header="Código"
                  sortable={sortable}
                  body={codBodyTemplate}
                  filter
                  filterMatchMode="contains"
                  filterPlaceholder={
                    filter.filters !== undefined &&
                    filter.filters.id !== undefined &&
                    filter.filters.id.value != null
                      ? filter.filters.id.value
                      : "Pesquisar pelo Código"
                  }
                />

                <Column
                  field="nome"
                  header="Nome"
                  sortable={sortable}
                  body={nomeBodyTemplate}
                  filter
                  filterMatchMode="contains"
                  filterPlaceholder={
                    filter.filters !== undefined &&
                    filter.filters.nome !== undefined &&
                    filter.filters.nome.value !== ""
                      ? filter.filters.nome.value
                      : "Pesquisar pelo nome"
                  }
                />

                <Column
                  field="cor"
                  header="Côr"
                  sortable={sortable}
                  body={corBodyTemplate}
                  filter
                  filterMatchMode="contains"
                  filterPlaceholder={
                    filter.filters !== undefined &&
                    filter.filters.cor !== undefined &&
                    filter.filters.cor.value !== ""
                      ? filter.filters.cor.value
                      : "Pesquisar pela observação"
                  }
                />

                {showActionsColumn && (
                  <Column header="Ações" body={actionBodyTemplate} />
                )}
              </DataTable>
            </div>
          </div>
        </div>
      </>
    );
}